"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFRESH_TOKEN_KEY = exports.ACCESS_TOKEN_KEY = void 0;
exports.ACCESS_TOKEN_KEY = 'access_token_key';
exports.REFRESH_TOKEN_KEY = 'refresh_token_key';
